import { useCallback } from "react"

export const useNavigationHandlers = ({
  selectedTableLevels,
  setSelectedTableLevels,
  onTableNavigationChanged,
  onRowClicked,
}) => {
  const handleSetTableLevel = useCallback((id, replaceLastTableLevelId = false) => {
    const currentLevels = selectedTableLevels || []
    let levelIdArray
    if (!id) {
      // Go up one level by removing the last item in the array
      levelIdArray = currentLevels.slice(0, -1)
    } else {
      // Navigate to a specific level
      levelIdArray = replaceLastTableLevelId
        ? [...currentLevels.slice(0, -1), id]
        : [...currentLevels, id]
    }
    setSelectedTableLevels(levelIdArray)
    onTableNavigationChanged?.(levelIdArray)
  }, [selectedTableLevels, setSelectedTableLevels, onTableNavigationChanged])

  const handleClickContributor = useCallback((contributorId, hasChildren) => {
    if (hasChildren) {
      handleSetTableLevel(contributorId)
    }
    onRowClicked?.(contributorId)
  }, [handleSetTableLevel, onRowClicked])

  return {
    handleSetTableLevel,
    handleClickContributor,
  }
}
